import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import api from "../../../services/api";
import {IEventResult} from "../../../interfaces/IEventResult";
import Swal from "sweetalert2";
import ResultsPrinting from "./ResultsPrinting";

export default function EventResultList() {
  const { id } = useParams()
  const [eventResults, setEventResults] = useState<IEventResult[]>([])
  const [showPrint, setShowPrint] = useState(false)
  const [eventEntry, setEventEntry] = useState<any>(null)

  const navigate = useNavigate()


  useEffect(() => {
      api.get(`/api/event_entries/${id}`)
          .then(entryResponse => {
              setEventEntry(entryResponse.data)
          })

      api.get('/api/event_results/entry/' + id)
        .then(resposta => {
            setEventResults(resposta.data)
        })
  }, [])

    function deleteResult(hab:any, index :any) {
        Swal.fire({
            title: 'Tem certeza que deseja excluir o resultado?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#198754",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                try{
                    // setLoading(true)

                    api['delete'](`/api/event_results/${hab?.id}`)
                        .then((result) => {
                            setEventResults(prev => prev.filter((_, i) => i !== index))
                            Swal.fire({
                                title: 'Sucesso!',
                                text: result.data.message,
                                icon: 'success',
                                timer: 3000
                            })
                        })
                        .catch(erro => {
                            // setLoading(false)
                            Swal.fire({
                                title: 'Erro!',
                                text: erro.response.data.message,
                                icon: 'error',
                            });
                        });
                }catch (err: any) {
                    // setLoading(false)
                    Swal.fire({
                        title: 'Erro!',
                        text: err,
                        icon: 'error',
                    })
                }
            }
        });
    }

  return (
      <>
          <div className='row'>
              <div className='col-md-12'>
                  <h3 className='mb-2'>
                      <b>Resultados</b>
                  </h3>
                  <h5 className='mb-2'>
                      <b>{eventEntry?.matchDate?.eventStage?.event.title} - {eventEntry?.matchDate?.eventStage?.title}</b>
                  </h5>
              </div>
          </div>

          <div className='row my-4'>
              <div className="col-lg-3">
                <Link to={"/results/create/" + id} className="btn btn-success w-100 my-1"><i
                    className="bi bi-plus-square-fill">&nbsp; </i> Cadastrar resultado</Link>
              </div>
              <div className="col-lg-3">
                <button className="btn btn-primary w-100 my-1" onClick={() => setShowPrint(true)}><i
                    className="bi bi-printer-fill">&nbsp; </i>Imprimir Resultados</button>
              </div>

                  <div className='col-md-12 mt-3'>
                      <div className='card'>
                          <div className='card-body'>
                              <table className="table table-striped">
                                  <thead>
                                  <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Atleta</th>
                                      <th scope="col">Total</th>
                                      <th scope="col"></th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                      {(eventResults != undefined && eventResults.length > 0) ? (
                                          <>
                                              {eventResults.map((result: IEventResult, index: number) =>
                                                  <tr key={`${index}`}>
                                                      <td>{index+1}</td>
                                                      <td>{result.athlete?.full_name}</td>
                                                      <td>{result.shot_totals}</td>
                                                      <td>
                                                          <Link to={'/results/' + result.id}
                                                                className='btn btn-sm btn-warning mx-1'  title="Editar"><i className="bi bi-pencil" aria-hidden="true"></i></Link>

                                                              <button type="button"
                                                                      className="btn btn-sm btn-danger mx-1"
                                                                      title="Excluir"
                                                                      onClick={() => deleteResult(result, index)}>
                                                                  <i
                                                                      className="bi bi-trash"
                                                                      aria-hidden="true"></i>
                                                              </button>

                                                      </td>
                                                  </tr>
                                              )}
                                          </>
                                      ) : (
                                          <tr>
                                              <td colSpan={7} className='text-center'>
                                                  Nenhuma habitualidade lançada
                                              </td>
                                          </tr>
                                      )}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>

          </div>

          <div className='row'>
              <div className='col-md-12 text-right'>
                  <button className="btn btn-danger btn-floating" onClick={() => navigate(-1)}>Voltar<br/></button>
              </div>
          </div>

          {showPrint && <ResultsPrinting eventEntryId={id} childToParent={() => setShowPrint(false)} />}
      </>
  )
}
